var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"website-container"},[_c('let-it-snow',_vm._b({attrs:{"show":_vm.show}},'let-it-snow',_vm.snowConf,false)),_c('transition',{attrs:{"name":"flip"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }